import React from 'react'
import Landing from '../routes/landings/Dining'

const Dining = () => {
  return <Landing />
}

export default Dining
